module.exports = "<app-recovery-menu></app-recovery-menu>\n<router-outlet></router-outlet>"


//////////////////
// WEBPACK FOOTER
// ./src/app/recovery/recovery.component.html
// module id = ./src/app/recovery/recovery.component.html
// module chunks = main